export interface ParsedEmbedScript {
  src?: string;
  innerHTML?: string;
}

export interface ParsedEmbed {
  /** Remaining markup with <script> tags stripped out, safe for dangerouslySetInnerHTML. */
  markup: string;
  scripts: ParsedEmbedScript[];
}

const SCRIPT_TAG_RE = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
const SRC_ATTR_RE = /\bsrc=["']([^"']+)["']/i;

/**
 * Splits a raw third-party embed blob (as an admin would paste it whole into
 * one textarea, e.g. a GoHighLevel inline form embed) into static markup and
 * its <script> tags. Browsers don't execute <script> tags inserted via
 * dangerouslySetInnerHTML, so the caller needs the scripts separated out to
 * inject as real DOM nodes (see useEmbedScripts) while the surrounding markup
 * (e.g. a container <div>) renders normally.
 */
export function parseEmbedHtml(html: string): ParsedEmbed {
  const scripts: ParsedEmbedScript[] = [];
  const markup = html.replace(SCRIPT_TAG_RE, (_match, attrs: string, body: string) => {
    const srcMatch = attrs.match(SRC_ATTR_RE);
    const src = srcMatch ? srcMatch[1] : undefined;
    const innerHTML = body.trim() || undefined;
    if (src || innerHTML) scripts.push({ src, innerHTML });
    return '';
  });
  return { markup: markup.trim(), scripts };
}
